import axios from 'axios';
import { useCallback } from 'react';
import { useWallet } from '@solana/wallet-adapter-react';

function useAxios(method) {
  const { publicKey } = useWallet();
  const fn = useCallback(
    (url, payload, options) => {
      return method(url, { ...payload, publicKey: publicKey?.toBase58() }, options);
    },
    [publicKey, method]
  );
  return fn;
}

export function usePost() {
  return useAxios(axios.post);
}

export function usePut() {
  return useAxios(axios.put);
}
